var map = {
	"./ID.webp": 812,
	"./INDO.webp": 813,
	"./MY.webp": 814,
	"./TH.webp": 815,
	"./VN.webp": 816,
	"./malaysia.webp": 817
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 373;
module.exports = webpackAsyncContext;